export default [
  {
    title: "Avtal",
    key: "CONTRACT",
    visited: true,
    hasError: false,
    fieldKeys: [
      "id_number",
      "start_date",
      "end_date",
      "renew_interval",
      "warning_interval",
      "notify_interval",
      "invoice_month_interval",
      "renew_indefinetely",
    ],
  },

  {
    title: "Fastighetsskatt & Indexuppräkning",
    key: "TAX",
    visited: false,
    hasError: false,
    fieldKeys: ["tenant_tax_billing_quota", "tax_mode", "index_base_date"],
  },
  {
    title: "Uppdatera",
    key: "CONFIRM",
    visited: false,
    hasError: false,
    fieldKeys: [],
  },
];
